import React from "react";

const Assesment: React.FC = () => {
  return <div>Assesment Content</div>;
};

export default Assesment;
